var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('DiagnosticDetail',{attrs:{"summary":_vm.storeData,"editable":true}}),_c('BillingDetailsModal',{attrs:{"appointment":_vm.storeData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }